import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from "./AppliedFilters.module.css";
import refresh from "./assets/refresh.svg";
import times from "./assets/times.svg";
import { visualizerActions } from "../../store"; // Import your actions

export default function AppliedFilters() {
    const dispatch = useDispatch();
    const appliedFilters = useSelector((state) => state.visualizer.appliedFilters);
    
    const removeFilter = (targetName, targetValue) => {
        // Dispatch action to remove the filter from Redux store
        dispatch(visualizerActions.removeAppliedFilter({ name: targetName, value: targetValue }));
    };

    const clearFilters = () => {
        // Dispatch action to clear all filters in the Redux store
        dispatch(visualizerActions.resetAppliedFilters());
    };

    // Generate a list of filter items
    const appliedFilterItems = appliedFilters.map((option, index) => (
        <button 
            key={index} 
            className={styles.filterItem} 
            onClick={() => removeFilter(option.name, option.value)}
            aria-labelledby={`${option.label} remove filter`}
        >
            <img src={times} alt="remove icon"/>{option.label}
        </button>
    ));

    if (appliedFilters.length === 0) {
        return false; 
    }

    return (
        <section className={styles.container}>
            <div className={styles.flexMenu}>
                <h1>Applied Filters:</h1>
                <ul>
                    {appliedFilterItems}
                </ul>
                <button className={styles.clearFilters} onClick={clearFilters}>
                    Clear Filters <img src={refresh} alt="refresh icon"/>
                </button>
            </div>
        </section>
    );
}
